import React from 'react';
import { connect } from 'react-redux';

import * as actions from '../../actions/school/school';

import SchoolComponent from '../../components/app/School/School';

const School = (props) => {
  return (
    <SchoolComponent {...props} />
  );
};

export default connect(({ school, user }) => ({ schoolMain: school.school, user }), actions)(School);

